<template>
    <content-loading row v-if="!modelLoaded" :loadingMessage="modelLoadingMessage" ></content-loading>
    <div v-else>
        <v-layout row class="mb-3">
            <v-flex xs12>
                <v-layout row>
                    <v-flex xs2 md1 align-self-center class="text-xs-center">
                        <v-avatar color="indigo">
                            <v-icon dark>business</v-icon>
                        </v-avatar>
                    </v-flex>
                    <v-flex xs10 md11>
                        <h1>{{company.profile.name}}</h1>
                        <small>Registered: {{ company.status.createdHuman }}</small>
                        |
                        <small>Modified: {{ company.status.updatedHuman }}</small>
                        |
                        <small>Version: {{ company.status.version || 'n/a' }}</small>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout row>
            <v-flex xs12>
                <v-card>
                    <v-tabs v-model="activeTab" dark>
                        <v-tab key="profile-tab" :to="{name: 'admin.company.profile', params: {uid: company.uid}}">Profile</v-tab>
                        <v-tab key="team-tab" :to="{name: 'admin.company.team', params: {uid: company.uid}}">Team</v-tab>
                        <!--<v-tab key="manage-tab" :to="{name: 'admin.company.manage', params: {uid: company.uid}}">Manage</v-tab>-->
                    </v-tabs>
                    <router-view :firebaseUser="firebaseUser" :user="user" :systemConfig="systemConfig" :company="model" :uid="uid"></router-view>
                </v-card>
            </v-flex>
        </v-layout>
        <!--<router-view :firebaseUser="firebaseUser" :user="user" :systemConfig="systemConfig" :company="model"></router-view>-->
    </div>
</template>

<script>
  import {LoadModelMixin} from '@/views/app/mixins'

  export default {
    name: 'company-root',
    mixins: [LoadModelMixin],
    props: {
      firebaseUser: {
        required: true
      },
      user: {
        required: true
      },
      systemConfig: {
        type: Object,
        required: true
      },
      uid: {
        // Company uid
        type: String,
        required: true
      }
    },
    data () {
      return {
        activeTab: null
      }
    },
    computed: {
      company () {
        // Simply an alias of model
        return this.model
      }
    },
    methods: {
      init () {
        this.loadModel()
      },
      getModelRef(uid) {
        return this.$firebaseClient.getCompanyRef(uid)
      }
    }
  }
</script>
